import { gql } from '@apollo/client';
import { PUBLIC_API_KEY_ITEM_FRAGMENT } from './public-api-key.fragments';

export const GET_PUBLIC_API_KEYS_QUERY = gql`
  query GetPublicApiKeys($partnerId: Int!, $includeDisabled: Boolean) {
    getPublicApiKeys(partnerId: $partnerId, includeDisabled: $includeDisabled) {
      ...PublicApiKeyItemFields
    }
  }
  ${PUBLIC_API_KEY_ITEM_FRAGMENT}
`;

export const CREATE_PUBLIC_API_KEY_MUTATION = gql`
  mutation CreatePublicApiKey($params: CreatePublicApiKeyInput!) {
    createPublicApiKey(params: $params) {
      ...PublicApiKeyItemFields
    }
  }
  ${PUBLIC_API_KEY_ITEM_FRAGMENT}
`;

export const ROTATE_PUBLIC_API_KEY_MUTATION = gql`
  mutation RotatePublicApiKey($params: RotatePublicApiKeyInput!) {
    rotatePublicApiKey(params: $params) {
      id
      oldApiKeyId
      newApiKeyId
      newApiKeyValue
      usagePlanId
    }
  }
`;

export const UPDATE_PUBLIC_API_KEY_MUTATION = gql`
  mutation UpdatePublicApiKey($params: UpdatePublicApiKeyInput!) {
    updatePublicApiKey(params: $params) {
      ...PublicApiKeyItemFields
    }
  }
  ${PUBLIC_API_KEY_ITEM_FRAGMENT}
`;

export const DELETE_PUBLIC_API_KEY_MUTATION = gql`
  mutation DeletePublicApiKey($params: DeletePublicApiKeyInput!) {
    deletePublicApiKey(params: $params)
  }
`;
